export default "__VITE_ASSET__D87kBWm9__"